import React, { useEffect, useState } from "react";
import { sendBulkMessageRequestToJobseeker } from "./utils";
import JobService from "./services/JobService";
import { Link } from "react-router-dom";

const BulkMessageToJobseekerRequest = ({ jobId, permission }) => {
  const [approveQuestionnaireWarning, setApproveQuestionnaireWarning] =
    useState(false);
  useEffect(() => {
    const performJobOperations = async () => {
      const job = await JobService.getJob(jobId);
      if (job && permission.toLowerCase() === "yes") {
        if (job.questionnaireApproval) {
          // if job questionnaire is approved send out the notication to the jobseekers
          sendBulkMessageRequestToJobseeker(jobId);
        } else {
          // show a message warning for the questionnaire approval
          setApproveQuestionnaireWarning(true);
        }
      }
    };

    performJobOperations();
  }, [jobId, permission]);

  return (
    <>
      <div className="bg-white p-6 rounded-lg lg:p-8">
        <h4 className="text-xl mb-6 text-indigo-800 flex items-center justify-center">
          {approveQuestionnaireWarning ? (
            <p>
              Request cannot be completed. Confirm the questionnaire first —
              click{" "}
              <Link
                to={`/login?next=questionnaire?job=${jobId}`}
                target="_blank"
                className="underline"
              >
                here
              </Link>{" "}
              to approve.
            </p>
          ) : (
            <p>
              Thank you for the confirmation.
              {permission.toLowerCase() === "yes" &&
                " We’ll ensure the assessment notification is sent to the jobseekers for this job, if it hasn’t been sent already."}
            </p>
          )}
        </h4>
      </div>
    </>
  );
};

export default BulkMessageToJobseekerRequest;
